import React, { useState } from 'react';
import { Select } from 'antd';

const AutoOpenSelect = (props) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (value, option) => {
    setOpen(false); 
    props.onSelect?.(value, option); 
  };

  const handleMouseDown = () => {
    setOpen(true); 
  };

  return (
    <Select
      {...props}
      open={open}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onSelect={handleSelect}
      onMouseDown={handleMouseDown}
    />
  );
};

export default AutoOpenSelect;
